import { render, staticRenderFns } from "./editTemplet.vue?vue&type=template&id=00ba6559&"
import script from "./editTemplet.vue?vue&type=script&lang=js&"
export * from "./editTemplet.vue?vue&type=script&lang=js&"
import style0 from "./editTemplet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports